import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-48" data-mp="e3didugelir3">
      <div className="mx-auto max-w-5xl" data-id="element-49" data-mp="9cszrbcd83e">
        <div className="mx-auto max-w-3xl text-center" data-id="element-50" data-mp="8bch7bk3tea">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-51" data-mp="57xr9l719hp7">
            Un modo migliore di insegnare arte
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-navy sm:text-5xl" data-id="element-52" data-mp="3rg75qmfes10b">
            Da Docente Sopraffatto a{' '}
            <span className="italic text-grape" data-id="element-53" data-mp="3diii56tyifrk">Guida Sicura.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-navy/60 sm:text-base" data-id="element-54" data-mp="3igk5i3yf118u">
            Arte Pronta trasforma ore di pianificazione estenuante in un sistema
            «apri e insegna». Entra in ogni lezione con un piano chiaro,
            attività che incantano gli alunni e la sicurezza di chi ha già tutto
            sotto controllo.
          </p>
        </div>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-55" data-mp="1f8invoe0uo6b">
          <div className="grid md:grid-cols-2" data-id="element-56" data-mp="1t18cm0kxq774">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-57" data-mp="1t32z3jbuu7db">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-navy/35" data-id="element-58" data-mp="1o2x35qyjxypf">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-59" data-mp="10edwtgz2bvzz" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-navy/40" data-id="element-60" data-mp="wcitk6xkn8jk">
                Il costo di partire da zero ogni giorno
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold tracking-wide text-navy" data-id="element-61" data-mp="15actdrujokbh">
                IL VECCHIO MODO
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-navy/55" data-id="element-62" data-mp="2gqji1vd8cprl">
                Stancante, improvvisato, mai finito.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-63" data-mp="2oqphyhkfeh6a">
                {beforeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-white/80 px-4 py-3 text-sm text-navy/60" data-id="element-64" data-mp="2srj4p7m4tpxl">
                    <CircleXIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy/30" aria-hidden="true" data-id="element-65" data-mp="32pyy5h8mtba9" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-66" data-mp="2f1ph0smd5bpg">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-teal text-white" data-id="element-67" data-mp="2f04lazobbmq0">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-68" data-mp="1md1qahiuhu4i" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-teal" data-id="element-69" data-mp="1rbv4yd9vbr69">
                Il sistema Arte Pronta
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold tracking-wide text-navy" data-id="element-70" data-mp="1jrtz76zxxqpv">
                CON ARTE PRONTA
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-navy/55" data-id="element-71" data-mp="19twf8vp46g32">
                La tua nuova realtà.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-72" data-mp="14ua02gpq6prm">
                {afterItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-navy-light px-4 py-3 text-sm font-medium text-navy" data-id="element-73" data-mp="10uj9oe442bnm">
                    <CircleCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-74" data-mp="r4q01inj46m0" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-navy/5 bg-cream px-6 py-4 text-center text-xs text-navy/50" data-id="element-75" data-mp="d3nct2kssq9i">
            Un sistema completo per pianificare meno e insegnare con più senso.
          </p>
        </div>
      </div>
    </section>;
}